import './visualize-flow-approval-report.scss';
var htmlContent = require('./visualize-flow-approval-report.html');
import { HttpService } from '../../core/http/http';
import { BaseModalContent } from '../../shared/components/base-modal-content';
import { ToastService } from '../../shared/services/toastService';
import { Validator } from '../../core/validator/validator';
import { TranslationService } from '../../core/translation/translation';
import { AuthenticationService } from '../../shared/services/authenticationService';

const renderMarkup = () => htmlContent;

export class visualizeFlowApprovalReportComponent extends BaseModalContent {
  constructor() {
    super(renderMarkup());
    this.toastService = new ToastService();
    this.httpService = new HttpService();
    this.authenticationService = new AuthenticationService();
    this._companies = [];
    this._areas = [];
  }

  onOpened() {
    this.init();
  }

  onLoading(callback) {
    Promise.all([this._loadAdminCompanies(), this._loadAdminAreas()])
      .then(() => {
        callback();
      })
      .catch(error => {
        this.toastService.exception((error && error.title) || 'service unavailable');
        console.error(error);
        callback();
      });
    return true;
  }

  _loadAdminCompanies() {
    const login = this.authenticationService.getAuthenticatedUser().login;
    return this.httpService
      .get(this.httpService.config.getFlowApprovalCompanies + login)
      .then(response => {
        this._companies = (response || []).sort((a, b) =>
          (a.nombre || '').localeCompare(b.nombre || '', undefined, { sensitivity: 'base' })
        );
      })
      .catch(error => {
        this.toastService.exception((error && error.title) || 'service unavailable');
        console.error(error);
      });
  }

  _loadAdminAreas() {
    const login = this.authenticationService.getAuthenticatedUser().login;
    return this.httpService
      .get(this.httpService.config.getFlowApprovalAreas + login)
      .then(response => {
        this._areas = (response || []).sort((a, b) =>
          (a.nombre || '').localeCompare(b.nombre || '', undefined, { sensitivity: 'base' })
        );
      })
      .catch(error => {
        this.toastService.exception((error && error.title) || 'service unavailable');
        console.error(error);
      });
  }

  init() {
    this._renderCompanies();
    this._renderAreas();

    this.parentModal.container.find('#btn-generate-report').click(() => this._generateReport());

    this.parentModal.container.find('#btn-cancel').click(() => {
      this.parentModal.close();
    });
  }

  _renderCompanies() {
    const container = this.parentModal.container.find('#companies-list');
    container.empty();

    if (!this._companies.length) {
      container.append(
        `<div class="checkbox-item"><label>${TranslationService.instance.translate(
          'reports-flow-approval-no-companies'
        )}</label></div>`
      );
      return;
    }

    this._companies.forEach(company => {
      container.append(`
        <div class="checkbox-item">
          <input type="checkbox" id="company-${company.idEmpresa}" value="${company.idEmpresa}" class="chk-company" />
          <label for="company-${company.idEmpresa}">${company.nombre}</label>
        </div>
      `);
    });
  }

  _renderAreas() {
    const container = this.parentModal.container.find('#areas-list');
    container.empty();

    if (!this._areas.length) {
      container.append(
        `<div class="checkbox-item"><label>${TranslationService.instance.translate(
          'reports-flow-approval-no-areas'
        )}</label></div>`
      );
      return;
    }

    this._areas.forEach(area => {
      container.append(`
        <div class="checkbox-item">
          <input type="checkbox" id="area-${area.idAreaInversion}" value="${area.idAreaInversion}" class="chk-area" />
          <label for="area-${area.idAreaInversion}">${area.nombre}</label>
        </div>
      `);
    });
  }

  _getSelectedCompanies() {
    return this.parentModal.container
      .find('.chk-company:checked')
      .map((_, el) => parseInt(el.value))
      .get();
  }

  _getSelectedAreas() {
    return this.parentModal.container
      .find('.chk-area:checked')
      .map((_, el) => parseInt(el.value))
      .get();
  }

  _getSelectedFlowTypes() {
    return {
      incluirPresupuestos: this.parentModal.container.find('#chk-flow-presupuestos').is(':checked'),
      incluirSolicitudes: this.parentModal.container.find('#chk-flow-solicitudes').is(':checked')
    };
  }

  _generateReport() {
    const selectedCompanies = this._getSelectedCompanies();
    const selectedAreas = this._getSelectedAreas();
    const flowTypes = this._getSelectedFlowTypes();

    if (!selectedCompanies.length || !selectedAreas.length) {
      this.toastService.error(
        TranslationService.instance.translate('exception-title'),
        TranslationService.instance.translate('reports-flow-approval-select-filters')
      );
      return;
    }

    if (!flowTypes.incluirPresupuestos && !flowTypes.incluirSolicitudes) {
      this.toastService.error(
        TranslationService.instance.translate('exception-title'),
        TranslationService.instance.translate('reports-flow-approval-select-flow-type')
      );
      return;
    }

    const login = this.authenticationService.getAuthenticatedUser().login;

    // Construir query string con los IDs seleccionados (arrays como parámetros repetidos)
    const companiesParams = selectedCompanies.map(id => `IdEmpresas=${id}`).join('&');
    const areasParams = selectedAreas.map(id => `IdAreasInversion=${id}`).join('&');
    const flowTypeParams =
      `IncluirPresupuestos=${flowTypes.incluirPresupuestos}` +
      `&IncluirSolicitudes=${flowTypes.incluirSolicitudes}`;
    const url = `${this.httpService.config.getFlowApprovalReport}?UsuarioSolicitante=${login}&${companiesParams}&${areasParams}&${flowTypeParams}`;

    const fileName = `InformeFlujoAprobaciones_${this._formatDate()}.pdf`;

    this.parentModal.container.find('#btn-generate-report').addClass('disabled');
    this.parentModal.toggleLoadingIcon(true);

    this.httpService
      .downloadFile(url, fileName)
      .then(() => {
        this.parentModal.close();
      })
      .catch(error => {
        this.toastService.exception((error && error.title) || 'service unavailable');
        console.error(error);
      })
      .finally(() => {
        this.parentModal.container.find('#btn-generate-report').removeClass('disabled');
        this.parentModal.toggleLoadingIcon(false);
      });
  }

  _formatDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }
}
